module.exports = __webpack_public_path__ + "img/groups.7cab5788.png";